export default "__VITE_ASSET__CbiAQeFF__"